// This page contains the routes of custom url for student and instructor

export const maintainance = '/maintenance';

const configLink = {
  student: {
    programDetail: '/student/program/', // id to be concatinated
    batchDetails: '/batch/', // id to be concatinated
    courseDetails: '/course/', // id to be concatinated
    application: '/application?course=', // id to be concatinated
    module: '/module/', // id to be concatinated
    moduleUnitId: '?unitId=',
    profile: '/profile',
    welcomeCourse: '/student/course',
    challenge: '/challenge'
  },
  instructor: {

  }
};
export const routeNames = {
  program: 'program',
  batch: 'batch',
  course: 'course',
  module: 'module'
};

export const routeUrl = {
  student: {
    home: '/student',
    program: `/student/${routeNames.program}/:programId/${routeNames.batch}/:batchId`,
    welcomeCourse: `/student/${routeNames.course}/:courseId`,
    courseDetails: `/student/${routeNames.program}/:programId/${routeNames.batch}/:batchId/${routeNames.course}/:courseId`,
    modules: `/student/${routeNames.program}/:programId/${routeNames.batch}/:batchId/${routeNames.course}/:courseId/${routeNames.module}/:moduleId`,
    profile: '/profile',
    editProfile: '/profile/edit',
    syllabus: '/student/syllabus',
    school: '/student/schools/:id/program',
    challenge: `/student/${routeNames.program}/:programId/challenge`,
    signUpInfo: '/signUpInfo',
    application: '/application',
    onboarding: '/welcome',
    accomplishment: '/accomplishment'
  }
};

export const FuseConstant = {
  syllabusCourse: '5b51c9a4308b0d1b5b8fb096'
}

export default configLink;
